import React from "react";
import {
  styled,
  TextField,
  StandardTextFieldProps,
  InputAdornment,
  Stack
} from "@mui/material";
import SelectInput from "./SelectInput";

interface SearchFieldWithFiltersInterface extends StandardTextFieldProps {
  placeholder?: string;
  height?: number;
  dateOptions?: { label: string; value: string }[];
  categoryOptions?: { label: string; value: string }[];
  typeOptions?: { label: string; value: string }[];
  onDateSelect?: () => void;
  onCategorySelect?: () => void;
  onTypeSelect?: () => void;
}

const StyledTextField = styled(TextField, {
  shouldForwardProp: prop => prop !== "height",
  name: "TextField"
})<{ height?: number }>(({ height, theme }) => ({
  paddingRight: 0,
  paddingTop: 0,
  paddingBottom: 0,
  height: height || 50,
  "& .MuiInput-root": {
    height: "100%"
  },
  "& .MuiInputAdornment-root": {
    color: theme.palette.common.white,
    justifyContent: "center",
    height: "100%",
    maxHeight: "100%",
    borderRadius: "0px 15px 15px 0px",
    "& .far": {
      textAlign: "center"
    }
  }
}));

const SearchIcon = styled(Stack)(({ theme }) => ({
  background: theme.palette.primary.main,
  width: 56,
  justifyContent: "center",
  height: "100%",
  maxHeight: "100%",
  borderRadius: "0px 15px 15px 0px"
}));

const FilterContainer = styled(Stack)(({ theme }: any) => ({
  width: 155,
  borderLeft: `1px solid ${theme.palette.common.borderGrey}`,
  height: "100%"
}));

const SearchFieldWithFilters = ({
  placeholder = "Search",
  height = 50,
  dateOptions,
  categoryOptions,
  typeOptions,
  onDateSelect,
  onCategorySelect,
  onTypeSelect,
  ...props
}: SearchFieldWithFiltersInterface) => {
  const EndAdornment = () => {
    return (
      <Stack direction="row" height="100%">
        {dateOptions &&
          <FilterContainer>
            <SelectInput
              placeholder="Date"
              options={dateOptions}
              roundedCorners={false}
              onChange={onDateSelect}
            />
          </FilterContainer>}
        {categoryOptions &&
          <FilterContainer>
            <SelectInput
              placeholder="Category"
              options={categoryOptions}
              roundedCorners={false}
              onChange={onCategorySelect}
            />
          </FilterContainer>}
        {typeOptions &&
          <FilterContainer>
            <SelectInput
              placeholder="Type"
              options={typeOptions}
              roundedCorners={false}
              onChange={onTypeSelect}
            />
          </FilterContainer>}
        <SearchIcon>
          <i className="far fa-search" />
        </SearchIcon>
      </Stack>
    );
  };
  return (
    <StyledTextField
      {...props}
      height={height}
      variant="standard"
      placeholder={placeholder}
      InputProps={{
        disableUnderline: true,
        endAdornment: (
          <InputAdornment position="end">
            <EndAdornment />
          </InputAdornment>
        ),
        autoComplete: "off"
      }}
    />
  );
};

export default SearchFieldWithFilters;
